<div class="te-container">
  <!-- Left sidebar: inserted tags -->
  @if (insertedTags.length > 0) {
    <div class="te-sidebar">
      <div class="te-sidebar-header">
        <i class="pi pi-tags"></i>
        <span>{{ 'TAG_EDITOR.INSERTED_TAGS' | transloco }}</span>
      </div>
      <div class="te-sidebar-list">
        @for (tag of insertedTags; track tag.id) {
          <div
            class="te-tag-item"
            [class.hovered]="hoveredTagId === tag.id || cursorTagId === tag.id"
            [style.--tag-color]="'#' + tag.color"
            [title]="tag.label"
            (mouseenter)="onSidebarMouseenter(tag.id)"
            (mouseleave)="onSidebarMouseleave(tag.id)"
            (click)="scrollToTag(tag.id)"
          >
            <div class="te-tag-content">
              <div class="te-tag-dot"></div>
              <i class="pi pi-tag te-tag-icon"></i>
              <span class="te-tag-label">{{ tag.label }}</span>
            </div>
            <button
              type="button"
              class="te-tag-remove"
              [title]="'TAG_EDITOR.REMOVE_TAG' | transloco"
              (click)="onRemoveTagClick(tag.id, $event)"
            >
              <i class="pi pi-times"></i>
            </button>
          </div>
        }
      </div>
    </div>
  }

  <!-- Right column: HugeRTE editor -->
  <div class="te-editor-col">
    <editor
      [init]="editorConfig"
      (onInit)="onEditorInit($event)"
      (onChange)="onEditorChange($event)"
      (onInput)="onEditorChange($event)"
      (onBlur)="onTouched()"
    ></editor>
  </div>
</div>

<!-- Tag selector dialog -->
<p-dialog
  [(visible)]="showTagSelector"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '500px', maxWidth: '90%' }"
  [contentStyle]="{ 'overflow-y': 'auto', 'max-height': '60vh' }"
  styleClass="tag-editor-tag-selector"
  appendTo="body"
  (onShow)="onTagSelectorShow()"
  (onHide)="closeTagSelector()"
>
  <ng-template pTemplate="header">
    <h3>{{ 'EVENT_EDITOR.SR_EVENT.INSERT_TAG' | transloco }}</h3>
    <div class="dialog-header-actions">
      @if (clientId) {
        <p-button
          icon="pi pi-book"
          [text]="true"
          [rounded]="true"
          severity="secondary"
          (onClick)="openIpJournalInNewTab()"
          [pTooltip]="'TAG_EDITOR.GO_TO_IP_JOURNAL' | transloco"
          tooltipPosition="bottom"
        />
      }
      @if (useInternalLoading && clientId) {
        <p-button
          icon="pi pi-refresh"
          [text]="true"
          [rounded]="true"
          severity="secondary"
          (onClick)="refreshTreeNodes()"
          [pTooltip]="'TAG_EDITOR.REFRESH_TAGS' | transloco"
          tooltipPosition="bottom"
        />
      }
    </div>
  </ng-template>

  @if (displayTreeNodes.length === 0) {
    <div class="empty-state">
      <i class="pi pi-folder-open empty-icon"></i>
      <h4>{{ 'TAG_EDITOR.NO_RECORDS_TITLE' | transloco }}</h4>
      <p>
        {{ 'TAG_EDITOR.NO_RECORDS_MESSAGE' | transloco }}
        @if (ipJournalUrl) {
          <a class="ip-journal-link" [href]="ipJournalUrl" target="_blank" rel="noopener noreferrer">
            {{ 'TAG_EDITOR.NO_RECORDS_LINK' | transloco }}
          </a>
        }
        .
      </p>
    </div>
  } @else {
    <p-tree
      [value]="displayTreeNodes"
      [filter]="true"
      [filterPlaceholder]="'TAG_EDITOR.SEARCH_TAGS' | transloco"
      selectionMode="single"
      [(selection)]="selectedTreeNode"
      (onNodeSelect)="onTreeNodeSelect($event)"
      [metaKeySelection]="false"
    ></p-tree>
  }
</p-dialog>
